import React, { Component } from 'react'

import classnames from 'classnames'

import { wrapperHighlightPin } from '../../../../components/shared/toggle-highlight-pin'
import { i18n } from '../../../../validator'
import Link from '../sn-link'

@i18n()
class Event extends Component {
    getSport = event => {
        const { t } = this.props
        const sports = event.sports ? event.sports.data : null

        if (sports === null) {
            return ''
        }

        if (sports.length > 1) {
            return t('moreSports')
        }

        return sports[0] ? sports[0].name : ''
    }

    getLocation = event => {
        if (event.locations && event.locations.data) {
            let find = event.locations.data.find(location => location.residence)
            if (find) {
                return find.formatted_address
            }

            return event.locations.data[0].formatted_address
        }

        return ''
    }

    static getOrganizer(event) {
        if (event.organisingGroup) {
            return event.organisingGroup.data
        }

        if (event.owner) {
            return event.owner.data
        }

        return ''
    }

    hasEnded = event => moment.utc(event.end_date).isBefore(moment.utc())

    render() {
        const {
            event,
            t,
        } = this.props

        const additionalInfo = event.additionalInfo ? event.additionalInfo.data : null

        if (!additionalInfo) {
            return null
        }

        // const organiser = Event.getOrganizer(event)
        const isOpponent = !!additionalInfo.opponent

        const pointStyle = {
            background: `${event.type_color}`,
        }

        return (
            <Link
                to={'/udalosti/' + event.slug}
                className={classnames({
                    'event-box': true,
                    'event-box--muted': this.hasEnded(event),
                })}
            >
                <div className="event-box__point" style={pointStyle} />
                <div className="event-box__sport">
                    <div className="event-box__sport--empty" />
                    <div className="event-box__sport--content">
                        {this.getSport(event)}
                    </div>
                </div>

                <div className="event-box__main">
                    <div className="event-box__images">
                        <div className="event-box__images--element">
                            <img src={additionalInfo.home.image} className="event-box__images--image" alt={t('eventLogoOfHomeImageAlternative')} />
                        </div>
                        <div className="event-box__images--element">
                            {isOpponent &&
                            <img src={additionalInfo.opponent.image} className="event-box__images--image" alt={t('eventLogoOfAwayImageAlternative')} />
                            }
                        </div>
                    </div>

                    <div className="event-box__content">
                        <div className="event-box__content-top">

                            <div className="event-box__name">
                                <div className={classnames({
                                    'event-box__name--oneline': isOpponent,
                                    'event-box__name--twoline': !isOpponent,
                                })}>
                                    {additionalInfo.home.name}
                                </div>
                                {isOpponent &&
                                <div className="event-box__name--oneline">
                                    {additionalInfo.opponent.name}
                                </div>
                                }
                            </div>

                            <div className="event-box__location">
                                {this.getLocation(event)}
                            </div>
                        </div>
                        <div className="event-box__content-bottom">
                            {additionalInfo.home.division &&
                            <div className="event-box__division">
                                {additionalInfo.home.division}
                            </div>
                            }

                            <div className="small color-main mt-1 mb-1">
                                {additionalInfo.formattedOrganiserGroupPath || additionalInfo.organiser}
                            </div>

                            <div className="event-box__box-date" title={additionalInfo.formattedYear}>
                                {additionalInfo.formattedDate}
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        )
    }
}

export default wrapperHighlightPin(Event, 'event')
